module.exports = __webpack_public_path__ + "img/icon-invite.b35048f8.svg";